/** @type {import('../help-index.js').HelpSidebarItem} */
export const ACC_JOU_CHART_ITEM = {
  id: 'chart_of_accounts',
  screenId: 'acc-jou-chart',
  label: 'Plan de cuentas',
  description: 'Árbol de cuentas contables imputables.',
  detail: {
    sections: [
      {
        title: 'Para qué sirve',
        intro:
          'Armás y mantenés el plan de cuentas: Activo, Pasivo, Patrimonio neto, Ingresos y Gastos, con códigos jerárquicos.',
      },
      {
        title: 'Paso 1 — Navegar el árbol',
        bullets: [
          'Secciones plegables por clase contable.',
          'Cada cuenta muestra código, descripción e indicador si admite imputación.',
          'Expandí/contraé con las flechas.',
        ],
      },
      {
        title: 'Paso 2 — Alta y edición',
        bullets: [
          'Agregar cuenta hija desde la fila padre (+ inline).',
          'Lápiz — editar código, descripción, si es imputable, activa.',
          'Exportar a Excel o CSV.',
        ],
      },
    ],
  },
}
